export default "__VITE_ASSET__DJQe35LQ__"